import articlesProfileSection from "../../components/articlesProfileSection/index.vue";

export default {
  name: "articlesProfile",
  components: {
    articlesProfileSection,
  },
};
